import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const SupportSection = ({ title, subtitle, copy }) => (
  <section id="support" className="px-6 py-20 md:py-28">
    <div className="max-w-7xl mx-auto">
      <div className="rounded-3xl border border-white/10 bg-white/5 p-10 md:p-12 backdrop-blur">
        <div className="max-w-3xl">
          <h2 className="text-3xl md:text-4xl font-bold text-[#f8f5ed] mb-3">
            {title || 'Support that shows up'}
          </h2>
          <p className="text-lg text-[#d8d2c5] mb-4">
            {subtitle || 'Humans for onboarding, migrations, and ongoing coaching.'}
          </p>
          <p className="text-sm text-[#d8d2c5]/85 leading-relaxed">
            {copy ||
              'Import legacy ledgers, map your roles, and train leaders with ready-to-ship playbooks. We stay close until your members run on autopilot.'}
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/register"
              className="inline-flex items-center gap-2 rounded-full bg-emerald-400 px-5 py-2.5 text-sm font-semibold text-[#0f1115] hover:bg-emerald-300 transition"
            >
              Create an account
            </Link>
            <Link
              to="/login"
              className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-5 py-2.5 text-sm font-semibold text-[#f4efe6] hover:bg-white/10 transition"
            >
              Contact support
            </Link>
          </div>
        </div>
      </div>
    </div>
  </section>
);

SupportSection.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  copy: PropTypes.string,
};

SupportSection.defaultProps = {
  title: null,
  subtitle: null,
  copy: null,
};

export default SupportSection;
